// extracted by mini-css-extract-plugin
module.exports = {"c_loading":"LoadingIcon_c_loading__2Jjny","spin":"LoadingIcon_spin__8IfKB","fadein":"LoadingIcon_fadein__wO4KH","fadein-slideup":"LoadingIcon_fadein-slideup__MH30F"};